var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useEffect, useState } from 'react';
import { getQueryParamByName } from '../utils/urlDecoder';
var fetchUnsubscribe = function (token) { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, fetch("/api/v1/notifications/unsubscribe?token=" + encodeURIComponent(token))];
            case 1:
                response = _a.sent();
                if (!response.ok && response.status !== 400 && response.status !== 410) {
                    throw new Error('Unsubscribe request failed');
                }
                return [2 /*return*/, response.json()];
        }
    });
}); };
var MineBokvarslerLink = function () { return (React.createElement(React.Fragment, null,
    ' ',
    React.createElement("a", { href: "/bokvarslinger" }, "Mine bokvarsler"),
    ".")); };
var UnsubscribeBody = function (_a) {
    var status = _a.status, bookTitle = _a.bookTitle;
    if (status === 'loading') {
        return React.createElement("p", null, "Fjerner bokvarsling \u2026");
    }
    if (status === 'unsubscribed') {
        return (React.createElement(React.Fragment, null,
            React.createElement("h2", null, "Bokvarslingen din er fjernet"),
            React.createElement("p", null,
                "Bokvarsling for ",
                React.createElement("strong", null, bookTitle || 'boka'),
                " har blitt fjernet.")));
    }
    if (status === 'expired') {
        return (React.createElement(React.Fragment, null,
            React.createElement("h2", null, "Kunne ikke fjerne bokvarsling"),
            React.createElement("p", null,
                "Muligheten for \u00E5 deaktivere bokvarslingen p\u00E5 denne boka har utl\u00F8pt. Om du ikke \u00F8nsker flere bokvarsler p\u00E5 denne boka kan du deaktivere den p\u00E5",
                React.createElement(MineBokvarslerLink, null))));
    }
    if (status === 'error') {
        return (React.createElement(React.Fragment, null,
            React.createElement("h2", null, "Kunne ikke fjerne bokvarsling"),
            React.createElement("p", null,
                "En ukjent feil har oppst\u00E5tt. Om du ikke \u00F8nsker flere bokvarsler p\u00E5 denne boka kan du deaktivere den p\u00E5",
                React.createElement(MineBokvarslerLink, null))));
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("h2", null, "Kunne ikke fjerne bokvarsling"),
        React.createElement("p", null,
            "Lenken er ugyldig. Om du ikke \u00F8nsker flere bokvarsler p\u00E5 denne boka kan du deaktivere den p\u00E5",
            React.createElement(MineBokvarslerLink, null))));
};
var NotificationsUnsubscribePage = function () {
    var token = getQueryParamByName('token');
    var _a = useState(token ? 'loading' : 'invalid'), status = _a[0], setStatus = _a[1];
    var _b = useState(null), bookTitle = _b[0], setBookTitle = _b[1];
    useEffect(function () {
        if (!token) {
            return undefined;
        }
        var cancelled = false;
        fetchUnsubscribe(token)
            .then(function (response) {
            var _a;
            if (cancelled) {
                return;
            }
            if (response.status === 'unsubscribed') {
                setBookTitle((_a = response.bookTitle) !== null && _a !== void 0 ? _a : null);
                setStatus('unsubscribed');
            }
            else if (response.status === 'expired') {
                setStatus('expired');
            }
            else {
                setStatus('invalid');
            }
        })
            .catch(function () {
            if (!cancelled) {
                setStatus('error');
            }
        });
        return function () {
            cancelled = true;
        };
    }, [token]);
    return (React.createElement("div", { className: "main-content" },
        React.createElement("h1", null, "Fjern bokvarsling"),
        React.createElement(UnsubscribeBody, { status: status, bookTitle: bookTitle })));
};
export default NotificationsUnsubscribePage;
